import { render } from "./Nieuws.vue?vue&type=template&id=22f8851c&ts=true"
import script from "./Nieuws.vue?vue&type=script&lang=ts"
export * from "./Nieuws.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__